import React, { useEffect } from 'react';
import {
  Label,
  Input,
  Row,
  Col,
  FormGroup,
  FormFeedback,
} from 'reactstrap';
import Text from '../../../components/Text';

const fieldName = 'primaryAccountKey';

export default function LeadsPersonalInfoView(props) {
  useEffect(() => {
    props.onChange({
      target: {
        name: fieldName,
        value: props.application?.accounts[0]?.id,
      },
    });
  }, [props]);

  return (
    <FormGroup>
      <Row>
        <Col sm="auto" className="label-main">
          <Label htmlFor="primaryAccountNo">
            <Text value="Choose the bank account where you receive your primary income:" />
          </Label>
        </Col>
      </Row>
      <Input
        type="select"
        name={fieldName}
        id={fieldName}
        value={props.formData.primaryAccountKey}
        onChange={props.onChange}
        invalid={props.validations[fieldName]?.isInvalid}
      >
        <option value="">Select your primary account</option>
        { props.application.accounts.map((a) => (
          <option key={a.id} value={a.id}>
            { `${a.name}: ${a.number}` }
          </option>
        )) }
      </Input>
      <FormFeedback>{ props.validations[fieldName]?.message }</FormFeedback>
    </FormGroup>
  );
}
